<template>
  <div class="modal animated is-active">
    <div class="modal-background"></div>
    <div class="modal-card is-large">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
      </header>
      <section class="modal-card-body">
        <p class="control is-expanded">
          <label class="label">User</label>
          <input class="input is-disabled" type="text" name="user" id="user" v-model="log.user">
        </p>
        <p class="control is-expanded">
          <label class="label">IP</label>
          <input class="input is-disabled" type="text" name="ip" id="ip" v-model="log.ip">
        </p>
        <p class="control is-expanded">
          <label class="label">Method</label>
          <input class="input is-disabled" type="text" name="method" id="method" v-model="log.method">
        </p>
        <p class="control is-expanded">
          <label class="label">Route</label>
          <input class="input is-disabled" type="text" name="route" id="route" v-model="log.route">
        </p>
        <p class="control is-expanded">
          <label class="label">URL</label>
          <input class="input is-disabled" type="text" name="url" id="url" v-model="log.url">
        </p>
        <p class="control is-expanded">
          <label class="label">Date</label>
          <input class="input is-disabled" type="text" name="date" id="date" v-model="log.date">
        </p>
        <template v-if="log.old_data || log.new_data">
          <vue-json-compare :oldData="log.old_data ? JSON.parse(log.old_data) : ''" :newData="log.new_data ? JSON.parse(log.new_data) : ''"></vue-json-compare>
        </template>
      </section>
      <footer class="modal-card-foot">
        <div class="control is-grouped is-pulled-right">
          <p class="control is-pulled-right">
            <a :class="{'button': true, 'is-primary': true, 'is-disabled': inProgress}" @click="close(true)">Close</a>
          </p>
        </div>
      </footer>
    </div>
  </div>

</template>

<script>
  import vueJsonCompare from 'vue-json-compare'
  export default {
    props: {
      context: {
        type: Object
      },
      callback: {
        type: String
      },
      title: {
        type: String
      },
      log_id: {
        type: Number
      }
    },
    data () {
      return {
        log: {
        },
        inProgress: false,
        error: ''
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.loadData()
      })
    },
    methods: {
      loadData () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/logs/' + this.log_id).then((response) => {
          this.log = response.body
          document.body.appendChild(this.$el)
        }, (response) => {
        })
      },
      close (closeOnly, result) {
        if (!closeOnly) {
          this.context[this.callback](result)
        }
        this.$el.remove()
      }
    },
    components: {
      vueJsonCompare
    },
    computed: {
      enterClass () {
        return `${this.transition}In`
      },
      leaveClass () {
        return `${this.transition}Out`
      }
    }
  }
</script>
<style lang="scss" scoped>
  .is-title {
    text-transform: capitalize;
  }

  .panel {
    background-color: white;
    box-shadow: 0 2px 3px rgb(167, 28, 32), 0 0 0 1px rgb(167, 28, 32);
    color: #4a4a4a;
    max-width: 100%;
    position: relative;
    border: 0;
    border-radius: 0;
  }

  .panel-heading {
    color: #FFFFFF;
    font-weight: bold;
    -ms-flex-align: stretch;
    align-items: stretch;
    display: -ms-flexbox;
    display: flex;
    min-height: 40px;
    box-shadow: 0 1px 0 rgb(167, 28, 32), 0 0 0 0 rgb(167, 28, 32);
    background-color: rgb(167, 28, 32);
    border-bottom: 0;
    border-radius: 0;
    font-size: 1rem;
  }
</style>



// WEBPACK FOOTER //
// Log.vue?5359e3ef